/**
 * stepper.js — ô số lượng [ − | 2 | + ] (mục 09): tối thiểu 1, tối đa 24 chai.
 *
 * Markup: .qty[data-stepper] > button[data-stepper-down] + input[data-stepper-input]
 *         + button[data-stepper-up]
 * Ô nhập vẫn là <input type="number"> nên gõ tay hoặc dùng phím mũi tên đều được;
 * hai nút chỉ là lối tắt cho chuột và cảm ứng. Hết giới hạn thì nút tương ứng bị
 * disabled để người dùng thấy ngay không bấm thêm được nữa.
 *
 * Mỗi lần đổi số, input phát sự kiện `change` (bubbles) — trang giỏ hàng nghe sự kiện
 * này để tính lại tiền, không cần biết số đổi bằng nút hay bằng bàn phím.
 * Stepper thêm vào trang SAU khi tải (dòng giỏ hàng vẽ bằng JS) vẫn chạy vì sự kiện
 * bắt ở document.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    function bounds(input) {
        var min = parseInt(input.getAttribute('min'), 10);
        var max = parseInt(input.getAttribute('max'), 10);
        return { min: isNaN(min) ? 1 : min, max: isNaN(max) ? 24 : max };
    }

    function sync(stepper) {
        var input = stepper.querySelector('[data-stepper-input]');
        if (!input) return;
        var b = bounds(input);
        var value = parseInt(input.value, 10);
        var down = stepper.querySelector('[data-stepper-down]');
        var up = stepper.querySelector('[data-stepper-up]');
        if (down) down.disabled = value <= b.min;
        if (up) up.disabled = value >= b.max;
    }

    function set(stepper, value) {
        var input = stepper.querySelector('[data-stepper-input]');
        if (!input) return;
        var b = bounds(input);
        if (isNaN(value)) value = b.min;
        value = Math.min(Math.max(value, b.min), b.max);
        if (String(value) !== input.value) {
            input.value = value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync(stepper);
    }

    document.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-stepper-down], [data-stepper-up]') : null;
        if (!button) return;
        var stepper = button.closest('[data-stepper]');
        var input = stepper ? stepper.querySelector('[data-stepper-input]') : null;
        if (!input) return;
        var step = button.hasAttribute('data-stepper-up') ? 1 : -1;
        set(stepper, (parseInt(input.value, 10) || 0) + step);
    });

    // Gõ tay số ngoài khoảng: sửa lại khi rời ô (không sửa giữa chừng lúc đang gõ)
    document.addEventListener('focusout', function (event) {
        var input = event.target;
        if (!input.matches || !input.matches('[data-stepper-input]')) return;
        set(input.closest('[data-stepper]'), parseInt(input.value, 10));
    });

    document.addEventListener('input', function (event) {
        var input = event.target;
        if (input.matches && input.matches('[data-stepper-input]')) sync(input.closest('[data-stepper]'));
    });

    [].slice.call(document.querySelectorAll('[data-stepper]')).forEach(sync);

    // Cho trang vẽ stepper bằng JS gọi lại để khoá nút đúng giới hạn
    window.WBStepper = { sync: sync };
})();
